<template>
  <module-page v-bind="pageParams">
    <template slot="header">
      <text-field
        v-model="searchQuery"
        placeholder="Busque pelo termo desejado"
        append-icon="bexsicon-search"
        hide-details
        class="search-field page__header__second__item"
      ></text-field>
    </template>
    <p v-if="faqItems.length && searchQuery">
      Exibindo
      <span style="font-weight: bold">
        "{{ filteredItemsLength }} resultado{{
          filteredItemsLength > 0 ? 's' : ''
        }}"
      </span>
      para
      <span style="font-weight: bold">"{{ searchQuery }}"</span>
    </p>
    <screen-loading v-if="faqLoading"></screen-loading>
    <div v-else class="faqs">
      <expansion-panel-list
        ref="faqList"
        focusable
        @togglePanel="createFaqTrace"
        :searchQuery="searchQuery"
        :searchKeys="['question', 'answer', 'themes']"
        :items="faqItems"
        icon-class-modifier="faq--color"
        @filteredItemsLength="updateFilteredItemsLength"
      >
        <template slot="header" slot-scope="item">
          <p class="faq-title">{{ item.item.question }}</p>
        </template>
        <template slot="content" slot-scope="item">
          <v-card class="faq pa-3">
            <div class="faq-answer" v-html="item.item.answer"></div>
          </v-card>
        </template>
      </expansion-panel-list>
      <div v-if="faqItems.length === 0 && !error" class="empty-state">
        {{ pageParams.emptyState }}
      </div>
      <div v-if="error" class="empty-state">
        {{ enums.responses.error }}
      </div>
    </div>
  </module-page>
</template>

<script>
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import ExpansionPanelList from '@/components/layout/ExpansionPanelList';
import faqMixin from '../../mixins/modules/faq';
import TextField from '@/components/fields/TextField';
import { APP } from '@/utils/constants';
export default {
  name: 'faq',
  mixins: [faqMixin],
  components: {
    ModulePage,
    ScreenLoading,
    ExpansionPanelList,
    TextField,
  },
  data() {
    return {
      pageParams: {},
      error: false,
      searchQuery: '',
      filteredItemsLength: 0,
    };
  },
  created() {
    this.pageParams = this.$store.getters[APP.PAGES].faq;
  },
  mounted() {
    this.getItems();
  },
  methods: {
    updateFilteredItemsLength(value) {
      this.filteredItemsLength = value;
    },
    async getItems() {
      await this.getFaqs();
      this.applyLinkedFaq();
    },
    createFaqTrace({ isOpened, item: faq }) {
      if (isOpened && faq)
        this.createTrace(this.enums.logTraceActions.faq, {
          question: faq.question,
        });
    },
    applyLinkedFaq() {
      if (this.$router.currentRoute.params.faq) {
        const faq = this.$router.currentRoute.params.faq;
        const index = this.faqItems.findIndex((f) => f._id === faq._id);
        this.$refs.faqList.toggleItem(index);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';
.faq {
  background-color: var(--field-disabled-bg-color) !important;
  &-answer {
    word-break: break-word;
  }
}
.search-field {
  margin-top: 0;
  height: 60px;
  font-size: 1em;
}
.faq-title {
  font-size: 1.2em;
  margin-right: 10px;
  margin-bottom: 0;
  color: var(--field-font-color);
}
</style>



// WEBPACK FOOTER //
// ./src/views/support/Faq.vue